import { Route } from '@angular/router';
import { adminAccessGuard } from '../features/admin/_guards/admin-access.guard';
import { AdminLayoutComponent } from '../features/admin/_ui/admin-layout/admin-layout.component';

const routes: Array<Route> = [
  {
    path: 'forbidden',
    loadComponent: () =>
      import('../features/admin/_ui/admin-forbidden/admin-forbidden.component').then(
        (module) => module.AdminForbiddenComponent,
      ),
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [adminAccessGuard],
    children: [
      {
        path: 'user',
        loadChildren: () =>
          import('../features/admin/admin-user/admin-user.routes').then(
            (module) => module.adminUserRoutes,
          ),
      },
      {
        path: '**',
        loadComponent: () =>
          import('../features/admin/admin-user/admin-user.component').then(
            (module) => module.AdminUserComponent,
          ),
      },
    ],
  },
];

export default routes;
